export const AUTH_TOKEN = "auth_token";
export const REFRESH_TOKEN = "refresh_token";
export const USER_TYPE = "user_type";
